module.exports = __webpack_public_path__ + "img/defaulEmpty.f9c3b268.png";